var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.951,
    height: 27.951,
    viewBox: "0 0 27.951 27.951",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.879,
    y1: 0.847,
    x2: 0.179,
    y2: 0.291,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M13.976,0A13.976,13.976,0,1,0,27.951,13.976,13.968,13.968,0,0,0,13.976,0Zm-2.24,2.4a11.945,11.945,0,0,1,4.479,0,14.1,14.1,0,0,1,2.593,6.194H9.144A14.1,14.1,0,0,1,11.736,2.4ZM2.184,13.976a11.848,11.848,0,0,1,.438-3.2H6.606a31.315,31.315,0,0,0,0,6.406H2.622A11.848,11.848,0,0,1,2.184,13.976Zm1.3,5.386H6.919a20.89,20.89,0,0,0,1.555,5.049A11.9,11.9,0,0,1,3.48,19.362ZM6.919,8.589H3.48A11.9,11.9,0,0,1,8.474,3.54,20.892,20.892,0,0,0,6.919,8.589Zm9.3,16.967a11.945,11.945,0,0,1-4.479,0,14.1,14.1,0,0,1-2.593-6.194h9.664A14.1,14.1,0,0,1,16.215,25.556Zm2.933-8.377H8.8a28.89,28.89,0,0,1,0-6.406H19.148a28.649,28.649,0,0,1,.178,3.2A28.649,28.649,0,0,1,19.148,17.179Zm5.324-8.589H21.033A20.89,20.89,0,0,0,19.478,3.54,11.9,11.9,0,0,1,24.471,8.589ZM19.478,24.411a20.888,20.888,0,0,0,1.555-5.049h3.439A11.9,11.9,0,0,1,19.478,24.411Zm1.868-7.233a31,31,0,0,0,.164-3.2,31,31,0,0,0-.164-3.2h3.984a11.922,11.922,0,0,1,0,6.406Z",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.950fffaa8fd57bf921edd031b57eea5e.svg";
export { ForwardRef as ReactComponent };